import gql from "graphql-tag";

export const UPDATE_FAVORITE_TAGS = gql`
    mutation UpdateFavoriteTags($tags: [String!]) {
        updatedUser: updateFavoriteTags(input: {tags: $tags}) {
            user {
                username
                email
                dateJoined
                profile {
                    displayName
                    sex
                    location
                    profession
                    workplace
                    biography
                    websiteUrl
                    twitterLink
                    facebookLink
                    birthday
                    phoneNumber
                }
                tagFavoriteSet {
                    edges {
                        node {
                            name
                        }
                    }
                }
            }
        }
    }
`;
